import {
  Component, OnInit, OnDestroy, Input, ViewChildren, ViewContainerRef, ComponentRef, QueryList,
  ComponentFactoryResolver, ComponentFactory
} from '@angular/core';
import { SinglePhoneComponent } from './single.phone.component';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'phone-questiontype',
  templateUrl: './phone.questiontype.component.html'
})
export class PhoneComponent implements OnInit, OnDestroy {
  @ViewChildren(SinglePhoneComponent) newvalues: QueryList<SinglePhoneComponent>
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  @Input() required:boolean;

  _phones:Array<any>;
  formSegment:FormGroup;
  phoneIdCount:number = 0;

  public getValue(){
    console.log(this.questionid);
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.newvalues.map((instance)=>{
        return instance.getValue();
      });
    } else {
      result[this.questionid]=null;
    }

    return result;
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return !this.newvalues.some((singlePhone)=>{
      return !singlePhone.isValid();
    });
  }
  validate():boolean {
    var result:boolean=true;

    if(!this.disabled) {
      this.newvalues.forEach((singlePhone)=>{
        if(!singlePhone.validate()) {
          result=false;
        }
      });
    }
    return result;
  }

  onRequestAdd(id:number){
    var i=0,found=false;
    while((i<this._phones.length) && !found) {
      if(this._phones[i].phoneChild===id) {
        found=true;
      } else {
        i++;
      }
    }
    if(found) {
      this._phones.splice(i+1,0,{
        phoneNumber:'',
        phoneType:'Cell',
        phoneChild:this.phoneIdCount++
      });
    } else {
      this._phones.push({
        phoneNumber:'',
        phoneType:'Cell',
        phoneChild:this.phoneIdCount++
      });
    }
  }

  onRequestSubtract(id:number){
    var i=0,found=false;
    if(this._phones.length > 1) {
      while((i<this._phones.length) && !found) {
        if(this._phones[i].phoneChild===id) {
          found=true;
        } else {
          i++;
        }
      }
      if(found) {
        this._phones.splice(i,1);
      }
    }
  }

  set value(phones:Array<any>){
    if(((typeof phones)=='object') && (phones instanceof Array) && (phones.length > 0)){
      this._phones=phones.map((phone)=>{
        phone.phoneChild=this.phoneIdCount++;
        return phone;
      });
    } else {
      this._phones=[{
        phoneNumber:'',
        phoneType:'Cell',
        phoneChild:this.phoneIdCount++
      }];
    }
  }

  constructor(
  ){
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/phone.questiontype.component.ts